import React, { useState, useRef } from 'react'
import Papa from 'papaparse'
import Button from '@material-ui/core/Button'
import useStyles from '../common/FormFields/FormFieldsStyle'

const CsvUpload = ({ handleChange }) => {
  const [data, setData] = useState([])
  const classes = useStyles()

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    Papa.parse(file, {
      complete: (result) => {
        const parsed = result.data.filter((row) => !!row.ci)
        setData(parsed)
        handleChange(parsed)
      },
      header: true,
    })
  }

  const inputRef = useRef()

  return (
    <div>
      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        ref={inputRef}
        style={{ display: 'none' }}
      />
      <Button
        variant="outlined"
        className={classes.secondaryButton}
        onClick={() => inputRef.current.click()}
      >
        Cargar archivo
      </Button>
    </div>
  )
}

export default CsvUpload
